/**
 * Patch promise to work in Backbone.
 * Should be removed once all .done and .fail
 * will be removed along with $.Deferred();
 */
export const patchPromiseState = (promise) => {
    let state = 'pending';

    if (promise.state) {
        return promise;
    }

    const patchPromise = promise.then((response) => {
        state = 'resolved';

        return response;
    }, (error) => {
        state = 'rejected';

        throw error;
    });

    patchPromise.state = () => state;

    return patchPromise;
};

export const patchPromise = (originPromise) => {
    const promise = patchPromiseState(originPromise);
    const originThen = promise.then.bind(promise);

    promise.then = function(doneCallback, failCallback) {
        return patchPromise(originThen(doneCallback, failCallback));
    };
    promise.done = function(callback) {
        return patchPromise(promise.then((response) => {
            // must not return anything
            callback(response);

            return response;
        }));
    };
    promise.fail = function(callback) {
        return patchPromise(promise.catch((error) => {
            const legacyError = error.response ?? error.request ?? error;

            // must not return anything
            callback(legacyError);

            throw legacyError;
        }));
    };
    promise.always = function(callback) {
        let result;

        return patchPromise(promise
            .then(response => result = response)
            .catch(error => {
                result = error.response ?? error.request ?? error;

                throw result;
            })
            .finally(() => callback(result))
        );
    };
    promise.promise = function() {
        return promise;
    };

    return promise;
};
